import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { CurrentUser } from "../../providers/current-user";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'logout-page',
  providers: [],
  styleUrls: ['./logout.scss'],
  standalone: true,
  imports: [
    MatProgressSpinner
  ],
  templateUrl: './logout.html'
})
export class LogoutPageComponent implements AfterViewInit {
    constructor(
        public breadcrumbProvider: BreadcrumbProvider,
        private router: Router,
        private currentUser: CurrentUser,
    ) {
    }

    public ngAfterViewInit() {
      this.breadcrumbProvider.setDefaultCrumbs([]);
      this.currentUser.logout().subscribe({
        next: () => {
          this.router.navigate(['']).then(r => r);
        },
        error: (error) => {
          this.onError(error);
          this.router.navigate(['']).then(r => r);
        }
      });
    }

    private onError(error: any): void {
        console.error("LOGOUT : ", error);
    }
}
